<template>
   <vx-card :title="id === null ? 'Cadastrar Estudante' : 'Editar Estudante'">
    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <StudentForm :services="services"
                     :studentId="computedId"
                     :studentEntity="studentEntity"
                     @update-data="handleUpdateDataStudent"></StudentForm>
      </vs-tab>
      <vs-tab label="Endereço" :disabled="isTabEnabled">
        <Address :services="services" :people_id="studentEntity.people_id" v-if="studentEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Telefone" :disabled="isTabEnabled">
        <Phone :services="services" :people_id="studentEntity.people_id" v-if="studentEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Email" :disabled="isTabEnabled">
        <Email :services="services" :people_id="studentEntity.people_id" v-if="studentEntity.people_id"/>
      </vs-tab>
    </vs-tabs>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import StudentService from '@/services/api/StudentService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'

import StudentForm from '../tabs/StudentForm'
import Address from '../tabs/Address'
import Email from '../tabs/Email'
import Phone from '../tabs/Phone'

export default {
  components: {
    vSelect,
    Address,
    Email,
    Phone,
    StudentForm
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    isTabEnabled() {
      return this.id === null
    },
    computedId() {
      return this.id ? Number(this.id) : null
    }
  },
  data: () => ({
    tabIndex: 0,
    studentEntity: {
      id: null,
      people_id: null,
      name: null,
      document: null,
      birthdate: null,
      email: null,
      status: null,
      description: null
    },
    services: {
      federationUnitService: null,
      cityService: null,
      studentService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null
    },
  }),
  methods: {
    loadData(){
      this.$vs.loading()
      this.services.studentService.read(this.computedId).then(
        data => {
          this.studentEntity.id = data.id
          this.studentEntity.people_id = data.people_id
          this.studentEntity.name = data.people.name
          this.studentEntity.document = data.people.document
          this.studentEntity.email = data.people.email
          this.studentEntity.birthdate = data.people.birthdate
          this.studentEntity.description = data.description

          this.$vs.loading.close()
        },
        error => {this.$vs.loading.close()}
      )
    },
    handleUpdateDataStudent(data){
      if(!this.computedId){ //Include
        this.$router.push(`/students/${data.id}/edit`)
        this.studentEntity = data
      }
    },
  },
  mounted() {
    if(this.id){
      this.loadData()
    }
  },
  beforeMount() {
    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.studentService = StudentService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
  }
}
</script>
